<app-header-search addText="Add Group" headerText="Group Management" />

<table>
  <thead>
    <tr>
      <th>Group Name</th>
      <th>Description</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Group 1</td>
      <td>Some Description</td>
      <td></td>
    </tr>
    <tr>
      <td>Group 1</td>
      <td>Some Description</td>
      <td></td>
    </tr>
    <tr>
      <td>Group 1</td>
      <td>Some Description</td>
      <td></td>
    </tr>
    <tr>
      <td>Group 1</td>
      <td>Some Description</td>
      <td></td>
    </tr>
  </tbody>
</table>
